import { render, staticRenderFns } from "./ConfirmationBox.vue?vue&type=template&id=22d05d41&scoped=true&"
import script from "./ConfirmationBox.vue?vue&type=script&lang=js&"
export * from "./ConfirmationBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d05d41",
  null
  
)

export default component.exports